import { cx } from '@libs/classnames';
import { InlineEditIcon } from '@ui/icons/InlineEditIcon';

import styles from './InlineEditButton.module.css';

export type Props = {
  className?: string;
  onClick?: () => void;
};
export function InlineEditButton({ className, onClick }: Props) {
  return (
    <span className={cx(styles.editButton, className)} onClick={onClick}>
      <InlineEditIcon />
    </span>
  );
}
